import { Config } from "../../configurations/config";

export const TimesheetStatusAPIs = {
	GetSupEmpList: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetSupervisorEmployeeWithJoiningDate`,
	GetSupEmpListForCM: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees?AllEmployees=false`,
	GetSupervisorList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsList`,
	GetSupervisorEmpListById: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorEmployeesById`,
	GetEmpTimesheetStatus: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetEmployeeTimesheetStatus`,
	GetStatusTypes: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetStatusTypes`,
	GetWeeklyTimeSheet: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetWeeklyTimeSheet`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/TimeSheet/ExportEmployeeTimesheetToExcel`,
};
